import { ChangeEvent, FC } from 'react';

import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Switch,
  SwitchProps,
} from '@mui/material';

type WaveUISwitchProps = SwitchProps & {
  name: string;
  label: string;
  checked?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  helperText?: string;
  fullWidth?: boolean;
  variant?: 'default' | 'label';
};

const WaveUISwitch: FC<WaveUISwitchProps> = ({
  name,
  label,
  checked,
  onChange,
  helperText,
  fullWidth = true,
  variant = 'default',
  ...props
}) => {
  const renderByVariant = () => {
    switch (variant) {
      case 'default':
        return (
          <FormControlLabel
            control={
              <Switch
                name={name}
                checked={checked}
                onChange={onChange}
                {...props}
              />
            }
            label={label}
          />
        );
      default:
        return (
          <>
            <InputLabel htmlFor={`id_${name}`}>{label}</InputLabel>
            <Switch
              name={name}
              checked={checked}
              onChange={onChange}
              {...props}
            />
          </>
        );
    }
  };

  return (
    <FormControl fullWidth={fullWidth}>
      {renderByVariant()}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default WaveUISwitch;
